export enum RevisionReviewStates {
  Unapproved = 'unapproved',
  RevisionInProgress = 'in_progress',
  RevisionPendingModeration = 'pending_moderation',
  Approved = 'approved',
}
